// Registry of per-user beta feature flags. Adding a feature = add an entry here.
// Flags are stored locally (localStorage) — see store/featureFlagsStore.ts.
// See AGENTS.md → "Feature flags".

export interface FeatureFlagDef {
  /** Stable key used by hasFeature(), nav gating and route gating. */
  key: string;
  /** i18n key for the human-readable feature name. */
  titleKey: string;
  /** i18n key for the short description shown on the opt-in page. */
  descKey: string;
  /** Reserved but not usable yet — shown disabled on the page. */
  comingSoon?: boolean;
}

export const FEATURE_FLAGS: FeatureFlagDef[] = [
  {
    key: 'developmentPlan',
    titleKey: 'featureFlags.items.developmentPlan.title',
    descKey: 'featureFlags.items.developmentPlan.desc',
  },
  {
    key: 'goalComments',
    titleKey: 'featureFlags.items.goalComments.title',
    descKey: 'featureFlags.items.goalComments.desc',
  },
  {
    key: 'questionnaireBuilder',
    titleKey: 'featureFlags.items.questionnaireBuilder.title',
    descKey: 'featureFlags.items.questionnaireBuilder.desc',
  },
  {
    key: 'reviewAnalytics',
    titleKey: 'featureFlags.items.reviewAnalytics.title',
    descKey: 'featureFlags.items.reviewAnalytics.desc',
  },
  {
    key: 'mapAiDraft',
    titleKey: 'featureFlags.items.mapAiDraft.title',
    descKey: 'featureFlags.items.mapAiDraft.desc',
  },
  {
    key: 'teamRolesDictionary',
    titleKey: 'featureFlags.items.teamRolesDictionary.title',
    descKey: 'featureFlags.items.teamRolesDictionary.desc',
  },
  {
    key: 'mapCardsView',
    titleKey: 'featureFlags.items.mapCardsView.title',
    descKey: 'featureFlags.items.mapCardsView.desc',
  },
  {
    key: 'rolesScreen',
    titleKey: 'featureFlags.items.rolesScreen.title',
    descKey: 'featureFlags.items.rolesScreen.desc',
  },
];

export const FEATURE_KEYS = FEATURE_FLAGS.map((f) => f.key);
